import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  textRight: {
    marginRight: -60,
  },
  textLeft: {
    marginRight: -30,
  },
  root: {},
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Switch/useStyles.js